import { Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { ProductType } from '@web/shared/module/shop';

export class AdminSubscriptionItem {
  public constructor(
    private readonly data: {
      name: string;
      slug?: Nillable<string>;
      type: ProductType;
      quantity: number;
      unitPrice: number;
      price: number;
      featuredFile?: Nillable<Multimedia>;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }

  public get type(): ProductType {
    return this.data.type;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get unitPrice(): number {
    return this.data.unitPrice;
  }

  public get price(): number {
    return this.data.price;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }
}
